import React, { useState } from 'react';
import TextInput from '../components/TextInput';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { generatePasswordResetCode } from '../api/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

const PasswordReset = () => {
    const navigate = useNavigate()

    const [email, setEmail] = useState('')

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return regex.test(email)
    }

    const toReset = () => {
        navigate('/password-reset')
    }

    const reset = async () => {
        const toastID = toast.loading('Resetting Password...', {
            position: 'top-center'
        })
        if (!validateEmail(email)) {
            toast.dismiss(toastID)
            toast.error('Invalid email format', {
                type: 'error',
                position: 'top-center',
                autoClose: 4000
            })
            return
        }
        const status = await generatePasswordResetCode({email: email.toLowerCase()})
        if (status == true) {
            // Dismiss toast
            toast.dismiss(toastID)
            toast.success('Password reset code sent', {
                type: 'success',
                position: 'top-center',
                autoClose: 4000
            })
        } else {
            toast.dismiss(toastID)
            toast.error(status.error, {
                type: 'error',
                position: 'top-center',
                autoClose: 4000
            })
        }

        
    }

    return (
        <div className="flex justify-center items-center py-16">
            <div className="shadow-lg px-12 py-8 flex flex-col">
                <div className="flex flex-row justify-center pb-4">
                    <p className="pt-2 font-medium text-2xl">Request Password Reset</p>
                </div>
                <div className="flex flex-col items-center">
                    <TextInput placeholder={'email'} text={email} setText={setEmail} isPassword={false}/>
                    <div className="pt-4">
                        <Button small={true} onClick={reset} text={'Email Reset Code'} />
                    </div>
                    <div className="pt-4 flex flex-row">
                        <p className="pt-2 pr-2 font-medium text-md">Have the code?</p>
                        <p onClick={toReset} className="pt-2 font-medium text-md hover:text-orange-500 cursor-pointer">Reset Password</p>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default PasswordReset